import { ca } from '@cian/analytics';

export const trackSendChatbotMessage = (text: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ChatBot',
    action: 'Click_sopr',
    label: 'sendMessage',
    page: {
      extra: {
        chat_id: 'chatbot',
        text,
      },
    },
  });
};
